angular.module('dentalLinks')
    .service('Logger', function() {
    
    var loggingEnabled = true;

    // Redact sensitive fields before logging to the console.
    // Rollbar monkey-patches console methods (for breadcrumbs), so anything we log may be captured.
    var SENSITIVE_KEYS = {
        password: true,
        password_confirmation: true,
        current_password: true,
        authentication_token: true,
        auth_token: true,
        token: true,
        access_token: true,
        refresh_token: true,
        secret: true,
        api_key: true
    };

    function isSensitiveKey(key) {
        if (!key) return false;
        var k = String(key).toLowerCase();
        return !!SENSITIVE_KEYS[k] || k.indexOf('password') !== -1 || k.indexOf('token') !== -1 || k.indexOf('secret') !== -1;
    }

    function sanitizeForLog(value, depth, seen) {
        if (depth > 6) return '[Truncated]';
        if (value === null || value === undefined) return value;
        var t = typeof value;
        if (t === 'string' || t === 'number' || t === 'boolean') return value;

        // Avoid circular references
        if (t === 'object' || t === 'function') {
            try {
                if (seen.has(value)) return '[Circular]';
                seen.add(value);
            } catch (e) {
                // WeakSet may throw for primitives / non-extensible objects; ignore
            }
        }

        // Errors can have huge / circular graphs; keep them compact
        if (value instanceof Error) {
            return { name: value.name, message: value.message, stack: value.stack };
        }

        // Dates should stay readable
        if (value instanceof Date) {
            return value.toISOString();
        }

        // Functions are not useful in logs (and can confuse JSON/stringifying)
        if (t === 'function') {
            return '[Function]';
        }

        // Arrays
        if (Array.isArray(value)) {
            return value.map(function(v) { return sanitizeForLog(v, depth + 1, seen); });
        }

        // Plain objects (including Angular $resource responses)
        var out = {};
        for (var key in value) {
            if (!Object.prototype.hasOwnProperty.call(value, key)) continue;
            if (isSensitiveKey(key)) {
                out[key] = '[REDACTED]';
            } else {
                out[key] = sanitizeForLog(value[key], depth + 1, seen);
            }
        }
        return out;
    }

    function sanitizeArgs(args) {
        var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : { has: function(){ return false; }, add: function(){} };
        return Array.prototype.slice.call(args).map(function(arg) {
            return sanitizeForLog(arg, 0, seen);
        });
    }
    
    this.log = function() {
        if (loggingEnabled) console.log.apply(console, sanitizeArgs(arguments));
    };
    
    this.debug = function() {
        if (loggingEnabled) console.log.apply(console, sanitizeArgs(arguments));//changed to .log() because debug() doesn't exist in IE10
    };
    
    this.info = function() {
        if (loggingEnabled) console.info.apply(console, sanitizeArgs(arguments));
    };
    
    this.warn = function() {
        if (loggingEnabled) console.warn.apply(console, sanitizeArgs(arguments));
    };
    
    this.error = function() {
        if (loggingEnabled) console.error.apply(console, sanitizeArgs(arguments));
    };
    
});
